import './no-payouts.scss';

import ComingSoon from '@basqet-dashboard/common/assets/icons/soon.svg';
import PropTypes from 'prop-types';
import React from 'react';

function NoPayouts({ searchTerm }) {
  return (
    <div className="no_payouts">
      <div className="no_payouts__coming_soon">
        <img src={ComingSoon} alt="Coming soon" />
      </div>
      <p className="no_payouts__message">
        {searchTerm
          ? `No payouts match your search for “${searchTerm}”. Try adjusting your filters or search term.`
          : 'No payouts available at the moment. Once you start sending or receiving payouts, they will appear here.'}
      </p>
    </div>
  );
}

NoPayouts.propTypes = {
  searchTerm: PropTypes.string
};

export { NoPayouts };
